var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrash = function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.526 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1h-10c-.552 0-1-.449-1-1V8h12v11Zm-8-14.672c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328Zm11 1.672h-5V4.328c0-1.284-1.12-2.328-2.5-2.328h-3c-1.379 0-2.5 1.044-2.5 2.328V6h-5c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z",
    fill: "#222B45",
    fillRule: "evenodd",
    opacity: 0.9
  })));
};
export default SvgIconTrash;